import { render } from "./electricityReadings.vue?vue&type=template&id=ef694e9c&scoped=true"
import script from "./electricityReadings.vue?vue&type=script&lang=js"
export * from "./electricityReadings.vue?vue&type=script&lang=js"

import "./electricityReadings.vue?vue&type=style&index=0&id=ef694e9c&scoped=true&lang=css"

import exportComponent from "/mnt/extra-storage/rentalkenya_vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ef694e9c"]])

export default __exports__